import React, { FC } from "react"
import { FooterProps } from "./Footer.interfaces"

export const Footer: FC<FooterProps> = () => {
  return <footer>&nbsp;</footer>
}
